module.exports = __webpack_public_path__ + "static/media/v-logo-white.1a29e4e6.svg";